import React from "react";
import "./Loader.scss";

const Loader = () => {
  return (
    <div>
      <span class="loader"></span>
    </div>
  );
};

export default Loader;
